(function () {
  var root = typeof window !== 'undefined' ? window : globalThis;

  if (root.mermaid && typeof root.mermaid.initialize === 'function') {
    return;
  }

  var namespace = root.__esbuild_esm_mermaid_nm;
  var candidate = namespace && namespace.mermaid;
  var mermaid = candidate && typeof candidate.initialize === 'function'
    ? candidate
    : candidate && candidate.default && typeof candidate.default.initialize === 'function'
      ? candidate.default
      : null;

  if (mermaid) {
    root.mermaid = mermaid;
  }
}());
